import React from 'react'

export const Header = () => {
  return (
    <div>Main Professional Website Header</div>
  )
}
